export const pageRoutes = {
  // ERORR PAGES
  ERROR_404: '/error/404',
  ERROR_403: '/error/403',
  ERROR_500: '/error/500',
  ERROR_COMING_SOON: '/error/coming-soon',
  ERROR_MAINTENANCE: '/error/maintenance',
  //  CARGO ROUTES
  SUBMIT_RECEIPT: '/cargo/submitReceiptList',
  CHECK_RECEIPT: '/cargo/checkReceiptList',
  REFUND_OR_VIOD: '/cargo/refundOrVoidList',
  CONFIRM_REFUND_OR_VIOD: '/cargo/ConfirmrefundOrVoidList',
  ISSUED_AWB_LIST: '/cargo/IssuedList',
  DRAFT_AWB_LIST: '/cargo/draftList',
  RESERVED_AWB_LIST: '/cargo/ReservedList',
  TEMPORARY_AWB_LIST: '/cargo/temporaryList',
  CCA_AWB_LIST: '/cargo/ccaList',
  RETURN_MONEY_LIST: '/cargo/returnMoneyList',
  TRANSACTIONS_LIST: '/cargo/transactionList',
  CREATE_AWB: '/cargo/createAwb',
  ISSUED_AWB: '/cargo/IssuedList',
  RESERVED_AWB: '/cargo/ReserveAWB',
  CHARGE_USER: '/cargo/Charge',
  CHARGE_DETAIL: '/cargo/ChargeUserDetail',
  COMMISION: '/cargo/Commission',
  REPORTS: '/cargo/report',
  C_R_C: '/cargo/customize-rate-class',
  MANIFEST: '/cargo/manifest',
  RATE_CLASS: '/cargo/rate-class',
  PRICING: '/cargo/pricing',
  PAYMENT_REDIRECT: '/cargo/paymentDetail',
  ONLINE_CHARGE_DETAIL: '/cargo/onlineChargeDetail',
  PAYMENT_REPORT: '/cargo/PaymentReport',
  USER_SETTINGS: '/cargo/userSettings',
  USER_CHARGE_DETAIL: '/cargo/UserChargeDetail',
  RTRD: '/cargo/RTRD',
};
